import React from 'react';

type IconProps = React.SVGProps<SVGSVGElement>;

const PatientIcon: React.FC<IconProps> = (props) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 2.49985C8.66304 2.49985 9.29893 2.76324 9.76777 3.23208C10.2366 3.70092 10.5 4.33681 10.5 4.99985C10.5 5.66289 10.2366 6.29877 9.76777 6.76761C9.29893 7.23646 8.66304 7.49985 8 7.49985C7.33696 7.49985 6.70107 7.23646 6.23223 6.76761C5.76339 6.29877 5.5 5.66289 5.5 4.99985C5.5 4.33681 5.76339 3.70092 6.23223 3.23208C6.70107 2.76324 7.33696 2.49985 8 2.49985ZM8 8.74985C10.7625 8.74985 13 9.8686 13 11.2498V12.4998H3V11.2498C3 9.8686 5.2375 8.74985 8 8.74985Z"
      fill="currentcolor"
    />
  </svg>
);

export default PatientIcon;
